'use strict';

var getPolyfill = require('./polyfill');
var define = require('define-properties');

module.exports = function shimEntries() {
	var polyfill = getPolyfill();
	define(Object, { entries: polyfill }, {
		entries: function testEntries() {
			return Object.entries !== polyfill;
		}
	});
	return polyfill;
};



//////////////////
// WEBPACK FOOTER
// ./~/object.entries/shim.js
// module id = 569
// module chunks = 35783957827783